import { render } from "./AIPolicyContent.vue?vue&type=template&id=aec83a04&scoped=true"
const script = {}

import "./AIPolicyContent.vue?vue&type=style&index=0&id=aec83a04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aec83a04"]])

export default __exports__